// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: {
      // This will be overridden by setClerkToken() when Clerk is available
    }
  }
});

/**
 * Set Clerk JWT as the authorization token for Supabase
 * This should be called whenever the Clerk session changes
 * 
 * IMPORTANT: Requires Supabase to be configured with Clerk's JWKS URL
 * in Authentication → Providers → Custom JWT
 */
export const setClerkToken = async (getToken: (() => Promise<string | null>) | null) => {
  if (!getToken) {
    // Clear auth if no token function provided
    Object.keys(supabase.rest.headers).forEach(key => {
      if (key.toLowerCase() === 'authorization') {
        delete supabase.rest.headers[key];
      }
    });
    supabase.rest.headers['Authorization'] = `Bearer ${SUPABASE_PUBLISHABLE_KEY}`;
    return;
  }

  try {
    const token = await getToken();
    if (token) {
      // CRITICAL: Set Authorization header on ALL Supabase request types
      // This ensures the Clerk JWT is sent with every API call
      
      // 1. Set on REST API client (for database queries)
      supabase.rest.headers['Authorization'] = `Bearer ${token}`;
      
      // 2. Set on Realtime client (for subscriptions)
      supabase.realtime.setAuth(token);
      
      // 3. Also set the access token in Supabase auth state
      // This ensures auth.jwt() in RLS policies can read it
      (supabase.auth as any).setSession?.({  
        access_token: token,
        refresh_token: '', // Not used with custom JWT
      });
      
      console.log('✅ Clerk JWT set for Supabase (all clients)');
    } else {
      console.warn('⚠️ No Clerk token available');
    }
  } catch (error) {
    console.error('❌ Failed to get Clerk token:', error);
  }
};
